import {
  MotorSubSection,
  MotorFunnelState,
  MotorSection,
  WireEdit,
} from 'scenes/motor/types';
import { toPageName } from './page';

export const toWireEdit = (
  state: MotorFunnelState,
  motorSection?: MotorSection,
  motorSubSection?: MotorSubSection
): WireEdit => ({
  pageName: toPageName(state),
  sectionName: motorSection || '',
  subSectionName: motorSubSection || '',
});
